import React, { useState } from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../mock';

// Mostra as 4 principais; "Ver todas as dúvidas" abre o resto (mesmo conteúdo de antes)
const FAQ = () => {
  const [todas, setTodas] = useState(false);
  const lista = todas ? faqs : faqs.filter((_, i) => [0, 1, 3, 6].includes(i));
  return (
    <section id="faq" className="bg-white py-[70px] lg:py-[110px] scroll-mt-20">
      <div className="max-w-[760px] mx-auto px-5 lg:px-8">
        <h2 className="text-center text-[30px] lg:text-[44px] font-black tracking-tight leading-tight text-slate-900">Dúvidas <span className="inn-text-gradient">frequentes</span></h2>
        <Accordion type="single" collapsible defaultValue="faq-0" className="mt-10 lg:mt-12 space-y-3">
          {lista.map((f) => {
            const i = faqs.indexOf(f);
            return (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-white rounded-2xl border-0 px-6 shadow-[0_6px_20px_rgba(15,23,42,0.05)]">
                <AccordionTrigger className="text-left font-extrabold text-[16px] lg:text-[17px] text-slate-900 hover:text-[#2A5BC7] hover:no-underline py-5">{f.question}</AccordionTrigger>
                <AccordionContent className="text-slate-500 text-[15.5px] leading-relaxed pb-5">{f.answer}</AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
        {!todas && faqs.length > 4 && (
          <button type="button" onClick={() => setTodas(true)} className="block mx-auto mt-5 text-[#2A5BC7] font-extrabold hover:underline">Ver todas as dúvidas →</button>
        )}
      </div>
    </section>
  );
};

export default FAQ;
